
































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import InputDatePicker from '@/components/molecules/InputDatePicker/InputDatePicker.vue'
import { VolumeMask, VolumeNumberMask, VolumeTotalMask } from '@/types'

export interface MagazineVolumeEditVolumeInfoItem {
  volume: {
    input: string
    errorMessage: string
  }
  volumeNumber: {
    input: string
    errorMessage: string
  }
  volumeTotal: {
    input: string
    errorMessage: string
  }
  dateLabel: {
    input: string
    errorMessage: string
  }
  dateIssue: {
    input: string
    errorMessage: string
  }
  specialType: {
    input: string
    errorMessage: string
  }
}

export const defaultMagazineVolumeEditVolumeInfoItem = (): MagazineVolumeEditVolumeInfoItem => ({
  volume: {
    input: '',
    errorMessage: ''
  },
  volumeNumber: {
    input: '',
    errorMessage: ''
  },
  volumeTotal: {
    input: '',
    errorMessage: ''
  },
  dateLabel: {
    input: '',
    errorMessage: ''
  },
  dateIssue: {
    input: '',
    errorMessage: ''
  },
  specialType: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: { InputDatePicker }
})
export default class MagazineVolumeEditVolumeInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: MagazineVolumeEditVolumeInfoItem

  get volumeMask(): string {
    return VolumeMask
  }

  get volumeNumberMask(): string {
    return VolumeNumberMask
  }

  get volumeTotalMask(): string {
    return VolumeTotalMask
  }

  get dateLabelMask(): string {
    return '#'.repeat(12)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
